import {
  type DataTableStateCopy,
  DEFAULT_EMPTY_MESSAGE,
  DEFAULT_NO_MATCH_MESSAGE,
  StateOverlay,
} from './state-overlay'

export type EmptyStateProps = {
  /** Whether the table has data behind the current filter. */
  hasAnyData: boolean
  copy?: DataTableStateCopy
}

/**
 * Empty state. Distinguishes no-data-at-all from no-match-for-filter via `hasAnyData`
 * so the copy is actionable; the preset keeps the toolbar/filters mounted outside so
 * a filtered-to-empty user can recover.
 */
export const EmptyState = ({ hasAnyData, copy }: EmptyStateProps) => {
  const message = hasAnyData
    ? (copy?.noMatchMessage ?? DEFAULT_NO_MATCH_MESSAGE)
    : (copy?.emptyMessage ?? DEFAULT_EMPTY_MESSAGE)

  return (
    <StateOverlay data-table-state={hasAnyData ? 'empty-no-match' : 'empty-no-data'}>
      <span className="text-sm text-text-secondary">{message}</span>
    </StateOverlay>
  )
}
